module.exports = __webpack_public_path__ + "img/thumbnail_AfricanCrestedPorcupine_m_normal.4379d3ff.png";